import type { ReactNode } from "react";

interface EmptyStateProps {
  title: string;
  message?: string;
  action?: ReactNode;
  variant?: "card" | "list" | "panel";
  className?: string;
}

export function EmptyState({ title, message, action, variant = "card", className = "" }: EmptyStateProps) {
  const rootClass =
    variant === "card"
      ? `mmm-card mmm-empty-state ${className}`.trim()
      : `mmm-empty-state mmm-empty-state--${variant} ${className}`.trim();

  if (variant === "card") {
    return (
      <div className={rootClass}>
        <h2>{title}</h2>
        {message && <p>{message}</p>}
        {action}
      </div>
    );
  }

  return (
    <div className={rootClass}>
      <strong>{title}</strong>
      {message && <span>{message}</span>}
      {action}
    </div>
  );
}
